import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n                color: ", ";\n                border-radius: ", ";\n                background-color: ", ";\n                box-shadow: ", ";\n            "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n                border-radius: ", ";\n                background-color: ", ";\n                box-shadow: ", ";\n            "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

function level(props) {
  var _props$theme = props.theme,
      shape = _props$theme.shape,
      palette = _props$theme.palette,
      shadow = _props$theme.shadow,
      level = props.level;

  switch (level) {
    case 'appBar':
    case 'popup':
    case 'modal':
      return css(_templateObject(), shape.borderRadius.large, palette.common.white, shadow[level]);

    case 'tooltip':
      return css(_templateObject2(), palette.common.white, shape.borderRadius.small, palette.gray.gray900, shadow[level]);

    default:
      return null;
  }
}

var StyledPaper = styled.div(_templateObject3(), level);
export var Paper = forwardRef(function (_a, ref) {
  var children = _a.children,
      _a$level = _a.level,
      level = _a$level === void 0 ? 'popup' : _a$level,
      props = __rest(_a, ["children", "level"]);

  return React.createElement(StyledPaper, Object.assign({}, props, {
    level: level,
    ref: ref
  }), children);
});
Paper.displayName = 'Paper';